import { __assign } from 'tslib';
import React__default, { useState } from 'react';
import { useTheme, useMediaQuery, Box, Drawer, AppBar, Toolbar, IconButton, Fab } from '@mui/material';
import clsx from 'clsx';
import DefaultIcon from '../../DefaultIcon/index.js';

var Layout = function Layout(_a) {
    var className = _a.className, testId = _a.testId, sx = _a.sx, leftSideBar = _a.leftSideBar, poiLayoutEnlarged = _a.poiLayoutEnlarged, actionBar = _a.actionBar, main = _a.main, tabs = _a.tabs, _b = _a.KIcon, KIcon = _b === void 0 ? DefaultIcon : _b, onPoiAnimationFinished = _a.onPoiAnimationFinished;
    var theme = useTheme();
    var isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    var _c = useState(false), poiOpen = _c[0], setPoiOpen = _c[1];
    var handleDrawerToggle = function () { return setPoiOpen(function (prevState) { return !prevState; }); };
    var sxTransition = {
        transition: "0.5s ease-in-out"
    };
    var gridTemplateColumns;
    var smallScreenWidth = poiLayoutEnlarged ? "90vw" : "60vw";
    if (isSmallScreen) {
        gridTemplateColumns = "0 minmax(0,1fr) minmax(0,1fr)";
    }
    else {
        gridTemplateColumns = "minmax(0,".concat(poiLayoutEnlarged ? "2" : "1", "fr) minmax(0,1fr) minmax(0,1fr)");
    }
    return (React__default.createElement(Box, { onAnimationEnd: onPoiAnimationFinished, className: clsx("KFThumbnailGenerator", className), "data-testid": testId, sx: __assign(__assign(__assign({}, sx), { display: "grid", gridTemplateAreas: "\"tabs ".concat(actionBar ? "header header" : "main main", "\" \"tabs main main\" \"tabs main main\""), gridTemplateColumns: gridTemplateColumns, gridTemplateRows: "min-content 1fr 1fr", height: "100%", width: "100%" }), sxTransition) },
        isSmallScreen ? (React__default.createElement(Drawer, { anchor: "left", open: poiOpen, onClose: handleDrawerToggle, onAnimationEnd: onPoiAnimationFinished },
            React__default.createElement(Box, { sx: {
                    gridArea: "tabs"
                } }, tabs),
            React__default.createElement(Box, { sx: __assign({ width: smallScreenWidth, height: "100%", overflow: "hidden" }, sxTransition) }, leftSideBar))) : (React__default.createElement(Box, { sx: {
                gridArea: "tabs",
                borderRight: function (theme) { return "1px solid ".concat(theme.palette.grey[300]); },
                display: "flex",
                flexDirection: "column"
            } },
            tabs,
            leftSideBar)),
        actionBar ? (React__default.createElement(Box, { sx: {
                gridArea: "header",
                backgroundColor: function (theme) { return "".concat(theme.palette.grey[50]); }
            } },
            React__default.createElement(AppBar, { position: "relative", elevation: 2, sx: {
                    // need to force zindex due to shadow issue
                    zIndex: 1
                } },
                React__default.createElement(Toolbar, null,
                    isSmallScreen && (React__default.createElement(IconButton, { edge: "start", color: "inherit", onClick: handleDrawerToggle },
                        React__default.createElement(KIcon, { className: "fa-regular fa-bars" }))),
                    actionBar)))) : (isSmallScreen && (React__default.createElement(Fab, { color: "primary", onClick: handleDrawerToggle, size: "small", sx: {
                top: "2px",
                left: "2px"
            } },
            React__default.createElement(KIcon, { className: "fa-regular fa-bars" })))),
        React__default.createElement(Box, { sx: {
                gridArea: "main",
                backgroundColor: function (theme) { return "".concat(theme.palette.grey[50]); },
                padding: 2,
                overflow: "auto"
            } }, main)));
};

export { Layout as default };
//# sourceMappingURL=index.js.map
